import { isChinese } from '@/utils/i18n';

const DEFAULT_ERROR = isChinese ? '未知错误' : 'Unknown error';

export default class ErrorModel {
  constructor(data = {}) {
    let message = '';
    let code;
    let type = 'unknown';

    if (data) {
      if (data.state) {
        // video center error
        code = data.state;
        type = 'Video Center API error';
      } else if (data.response) {
        // new api
        if (data.response.data && data.response.data.error) {
          ({ message, code } = data.response.data.error);
        } else {
          message = data.statusText;
          code = data.status;
        }
        type = 'API error';
      } else {
        message = data.statusText;
        code = data.status;
        type = 'API error';
      }

      message = message || data.msg || data.message;
      code = code !== undefined ? code : (data.status || data.code || 0);
    }

    this.message = `[${type}][${code}] ${message || DEFAULT_ERROR}`; // used for sentry
    this.code = code;
    this.name = data.name || type;
  }

  getMessage() {
    return this.message;
  }

  getCode() {
    return this.code;
  }

  isInvalidCSRF() {
    return this.getCode() === 403 && this.getMessage() === 'Invalid CSRF token';
  }
}
